import { Book } from "@/types/book";
import BookCard from "./BookCard";

interface BookGridProps {
  books: Book[];
  title?: string;
}

const BookGrid = ({ books, title }: BookGridProps) => {
  if (books.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="text-muted-foreground text-lg">No books found</p>
      </div>
    );
  }

  return (
    <section className="py-12">
      {title && (
        <h2 className="text-3xl font-bold mb-8 text-center animate-fade-in">
          {title}
        </h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {books.map((book, index) => (
          <div
            key={book.id}
            className="animate-scale-in"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <BookCard book={book} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default BookGrid;
